import { inject, Injectable, linkedSignal, signal } from '@angular/core';
import { SOFTLINE_VIRTUAL_KEYBOARD, VirtualKeyboardConfig } from './keyboard.tokens';

@Injectable({ providedIn: 'root' })
export class VirtualKeyboardService {
  readonly #_keyboardConfig = inject(SOFTLINE_VIRTUAL_KEYBOARD, { optional: true });

  readonly #keyboardConfig = signal<VirtualKeyboardConfig>(
    this.#_keyboardConfig ?? false
  );

  readonly #open = signal(false);

  readonly #enabled = linkedSignal(() => {
    const config = this.#keyboardConfig();
    return typeof config === 'boolean'
      ? config
      : config?.input === true || config?.textarea === true;
  });

  readonly open = this.#open.asReadonly();
  readonly enabled = this.#enabled.asReadonly();
  readonly config = this.#keyboardConfig.asReadonly();

  enable(): void {
    this.setConfig(true);
  }

  disable(): void {
    this.setConfig(false);
  }

  setConfig(config: VirtualKeyboardConfig) {
    this.#keyboardConfig.set(config);
  }

  openKeyboard(): void {
    this.#open.set(true);
  }

  closeKeyboard(): void {
    this.#open.set(false);
  }
}
